import React from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

const NoDataPage = ({
  flex,
  showBtn,
  BtnText,
  width,
  mainfileActivity,
  investorSearch,
  commingSoon,
  bgTransparent,
}: {
  flex?: boolean
  showBtn?: boolean
  BtnText?: string
  width?: any
  mainfileActivity?: boolean
  investorSearch?: string
  commingSoon?: boolean
  bgTransparent?: boolean
}) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  return (
    <div
      className={`pt-5 ${mainfileActivity ? '' : 'no-data-page-share-drawer'
        } w-100 ${bgTransparent ? 'bg-transparent' : 'bg-white'} d-flex align-items-center justify-content-center h-100 rounded-1`}
    >
      <div
        className={`text-center ${flex ? 'flex-column' : 'flex-row'} gap-15 align-items-center ${width ? width : 'width'
          }`}
      >
        <div style={{ order: flex ? 2 : 1 }}>
          <img
            src={toAbsoluteUrl('/media/icons/investor-updates/NoDataImg.svg')}
            alt='no-data-img'
            height={200}
            width={200}
          />
        </div>
        <div className='w-100 mt-8' style={{ order: flex ? 1 : 2 }}>
          {!commingSoon ? (
            <>
              {' '}
              <h1>{formatMessage({ id: 'Nothing to show' })}</h1>
              {investorSearch && (
                <h1>
                  {formatMessage({ id: 'for search result: ' })}
                  {investorSearch}
                </h1>
              )}
              <p className='w-100 px-10'>
                {formatMessage({
                  id: "Currently we don't have anything to show here",
                })}
              </p>
            </>
          ) : (
            <>
              <h1>{formatMessage({ id: 'Coming Soon' })}</h1>
              <p className='w-100 px-10'>
                {formatMessage({
                  id: 'Stay tuned for something amazing.',
                })}
              </p>
            </>
          )}
          {showBtn === false || showBtn === undefined ? null : (
            <div>
              {' '}
              <button
                className='btn btn-bg-primary custom-button-property font-size-13 text-white font-weight-400 w-125px'
                onClick={() => {
                  navigate('/data-rooms/files')
                }}
              >
                {formatMessage({ id: BtnText })}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default NoDataPage
